export function NotAuthorizedScreen() {
  return (
    <div>
      <p>You are not authorized</p>
      <p>go to login page</p>
    </div>
  )
}
